export default "__VITE_ASSET__b4e6751b__"